module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_gift.ver2_0_2.png?58a0201d";